import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IGroup } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Router } from '@angular/router';

@Component({
  selector: 'inc-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss'],
})
export class GroupListComponent {
  @Input() groupList: IGroup[];
  @Output() inactivateGroup: EventEmitter<IGroup> = new EventEmitter();

  constructor(private router: Router) { }

  stopProp(event: Event) {
    event.stopPropagation();
  }

  navigateTo(url: string, group: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    localStorage.removeItem('group');
    this.router.navigateByUrl(url, { state: { parameter: group } });
  }

  inactivation(group) {
    this.inactivateGroup.emit(group);
  }
}
